/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions

==========================================================================================*/

import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  setActiveChatUser({ commit }, value) {
    commit('SET_ACTIVE_CHAT_USER', value)
  },
  updateVideoChatData({ commit }, value) {
    commit('UPDATE_VIDEO_CHAT_DATA', value)
  },
  updateAboutChat({ commit, rootState }, value) {
    commit('UPDATE_ABOUT_CHAT', {
      rootState,
      value
    })
  },
  updateStatusChat({ commit, rootState }, value) {
    commit('UPDATE_STATUS_CHAT', {
      rootState,
      value
    })
  },
  sendChatMessage({ getters, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('chats', payload)
        .then(response => {
          payload.chatData = getters.chatDataOfUser(payload.to)
          payload.data = response.data
          commit('SEND_CHAT_MESSAGE', payload)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  // Get contacts from server. Also change in store
  fetchContacts({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      const query = QuerySerialize({
        owner: rootState.AppActiveUser.id
      })
      axios
        .get(`contacts?${query}`)
        .then(response => {
          commit(
            'UPDATE_CONTACTS',
            response.data.length ? response.data[0] : { whitelist: [], blacklist: [] }
          )
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchContactsStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/sockets/status', payload)
        .then(response => {
          commit('UPDATE_CONTACTS_STATUS', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  markSeenAllMessages({ getters, commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`chats/seen_contact/${id}`)
        .then(response => {
          commit('MARK_SEEN_ALL_MESSAGES', {
            id,
            chatData: getters.chatDataOfUser(id)
          })
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchUserChats(context, rootState, payload = { skip: 0, limit: 500 }) {
    const query = QuerySerialize({
      $or: [
        { from: rootState.AppActiveUser.id, to: payload.id },
        { from: payload.id, to: rootState.AppActiveUser.id }
      ]
    })
    return new Promise((resolve, reject) => {
      axios
        .get(`chats/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('UPDATE_USER_CHATS', { id: payload.id, data: response.data })
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchChats(context, payload = { skip: 0, limit: 500, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`chats/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('UPDATE_CHATS', { id: context.rootState.AppActiveUser.id, chats: response.data })
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchChat(context, chatId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`chats/${chatId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countChats(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`chats/count/?${query}`)
        .then(response => {
          context.commit('SET_CHAT_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeChat({ commit }, chatId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`chats/${chatId}`)
        .then(response => {
          commit('REMOVE_RECORD', chatId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editChat(context, chat) {
    return new Promise((resolve, reject) => {
      axios
        .put(`chats/${chat.id}`, chat.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
